module.exports = __webpack_public_path__ + "media/application/images/svgs/twitch-2a1c08a949e6e5fc74e08d73a2db6b81.svg";